const initialState = {
  cigarRecipeDataForTooltip: null,

  loading: 'idle',
};

export default initialState;
